export default __webpack_public_path__ + "static/media/ir_black_logo.7080aa54.png";